import React, { useState } from "react";
import FileUpload from "../../Common/FileUpload";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverAssetsAction from "../../../store/actions/DriverAssets";
import * as UserActions from "../../../store/actions/User";
import Errors from "../../../constants/Errors.json";
import variables from "../../../constants/assets/variables";
import InformationBar from "../../Common/InformationBar";
import NoFooterModal from "../../Common/NoFooterModal";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";

const BulkUploadDriverAssetsModal = (props) => {
  const { handleClose, bulkUploadDriverAssets, setStatus } = props;
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const sample_download_url = `${
    process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace(
          variables.routeEndpoint,
          variables.sampleFileEndPoint
        )}/sample/bulk_upload_driver_asset.csv`
      : ""
  }`;

  const instructions = [
    "<p>Allowed actions are <b>ADD</b></p>",
    "<p>Provide driver_id as FEXXXXX.</p>",
    "<p>Provide asset_name as <b>(Bag/T Shirt/Helmet/All Weather Jacket).</b>It is case sensitive and also be careful with spaces.</p>",
    "<p>If driver has multiple different asset then add it to separate row.</p>",
    "<p>There should be no space in name of the file. For example,<b>bulk_upload_asset_modifier (1).csv</b> is not allowed.</p>",
    "<p>Please refrain from putting anything else in columns other then the four (FE_id,action,asset_name,quantity,size), as it may effect the processing of the file and can result in failures.</p>",
  ];

  const handleUpload = () => {
    const payload = { filename: activeFile.name.replace(".csv", "") };
    bulkUploadDriverAssets(payload).then((res) => {
      if (res) {
        setCallback_key(res.callback_key);
        setPresign_url(res.file_upload_url);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  return (
    <NoFooterModal
      header
      heading="Bulk upload driver assets"
      handleClose={handleClose}
      id="BulkUploadAssetsDashboard"
      modalButtons={
        <BottomSectionModal className="mt-20">
          <Button
            disabled={activeFile == ""}
            onClick={handleUpload}
            className="sushi-btn"
          >
            Confirm
          </Button>
        </BottomSectionModal>
      }
    >
      <InformationBar
        sampleUrl={sample_download_url}
        instructions={instructions}
      />
      <FileUpload
        title={"CSV File"}
        uploadUrl="/driver-assets/bulk"
        callback_key={callback_key}
        presign_url={presign_url}
        handleClose={handleClose}
        keyName="callback_key"
        activeFile={activeFile}
        setActiveFile={setActiveFile}
      />
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    bulkUploadDriverAssets: bindActionCreators(
      DriverAssetsAction.bulkUploadDriverAssets,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkUploadDriverAssetsModal);
